// extracted by mini-css-extract-plugin
export var $animation_name = "ChildHeader-module--$animation_name--f03ab";
export var Block = "ChildHeader-module--Block--acb2f";
export var Block__block = "ChildHeader-module--Block__block--8bad2";
export var Block__block___image = "ChildHeader-module--Block__block___image--e323a";
export var Block__block___video = "ChildHeader-module--Block__block___video--6fb82";
export var Block__cover = "ChildHeader-module--Block__cover--d7b16";
export var Block__cover___cleared = "ChildHeader-module--Block__cover___cleared--efa11";
export var Block__innerBlock = "ChildHeader-module--Block__innerBlock--51350";
export var ChildHeader = "ChildHeader-module--ChildHeader--21fd6";
export var ChildHeader___hasBlock = "ChildHeader-module--ChildHeader___hasBlock--5ebe2";
export var ChildHeader___hasNoBlock = "ChildHeader-module--ChildHeader___hasNoBlock--a0079";
export var ChildHeader__black = "ChildHeader-module--ChildHeader__black--c400a";
export var ChildHeader__blurb = "ChildHeader-module--ChildHeader__blurb--a95e9";
export var ChildHeader__burgundy = "ChildHeader-module--ChildHeader__burgundy--9200d";
export var ChildHeader__links = "ChildHeader-module--ChildHeader__links--7a25c";
export var ChildHeader__navy = "ChildHeader-module--ChildHeader__navy--8f654";
export var ChildHeader__red = "ChildHeader-module--ChildHeader__red--a0c21";
export var ChildHeader__row = "ChildHeader-module--ChildHeader__row--4d7f4";
export var ChildHeader__title = "ChildHeader-module--ChildHeader__title--cc163";
export var ChildHeader__yellow = "ChildHeader-module--ChildHeader__yellow--a4197";
export var Inner = "ChildHeader-module--Inner--5b93b";